import { initViewMode } from '@/javascripts/editor/init_view_mode';

document.addEventListener('DOMContentLoaded', () => {
  initViewMode();
});
